module.exports = __webpack_public_path__ + "img/logo2.b40d7bf4.png";